import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { CONSTANTS } from '../../../constants';
import api from '../../../shared/api'; // FIXME: Temporary solution..

export var ProgressMonitorLayer =
/*#__PURE__*/
function () {
  function ProgressMonitorLayer() {
    _classCallCheck(this, ProgressMonitorLayer);

    this.baseUri = CONSTANTS.API.ENDPOINTS.PROGRESS;
  }

  _createClass(ProgressMonitorLayer, [{
    key: "poll",
    value: function poll(id) {
      // FIXME: This should be progress monitor endpoint
      var pollPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.DATA_UPLOAD, "/").concat(id, "?timestamp=").concat(new Date().getTime())).get({
        responseType: 'json'
      });
      return pollPromise;
    }
  }, {
    key: "status",
    value: function status(id) {
      var statusPromise = api("".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.STATUS, "/").concat(id)).get({
        responseType: 'json'
      }).then(function (response) {
        return response.data;
      });
      return statusPromise;
    }
  }, {
    key: "statusAggregation",
    value: function statusAggregation(ids) {
      var statusPromise = api("".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.STATUS_AGGREGATION)).post(ids, {
        responseType: 'json'
      }).then(function (response) {
        return response.data;
      });
      return statusPromise;
    }
  }, {
    key: "find",
    value: function find(tag) {
      var findPromise = api("".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.FIND)).post({
        tag: tag
      }, {
        responseType: 'json'
      }).then(function (response) {
        return response.data.result;
      });
      return findPromise;
    }
  }]);

  return ProgressMonitorLayer;
}();